import React from 'react';
import PropTypes from 'prop-types';
import Logo from '../../Header/Logo';
import MainNavigation from '../../../components/Header/MainNavigation';
import './CheckoutHeader.scss';

const noop = () => { };

class CheckoutHeader extends React.Component {
  static propTypes = {
    model: PropTypes.object.isRequired,
  };

  render() {
    const navigationModel = this.props.model.prismicNavigationModel;
    const countryModel = this.props.model.countryModel;

    return (
      <div className="header-wrap header-wrap--checkout">
        <header
          className="header-checkout">
          <div className="container-guttered-on-desktop-up">
            <div className="header-navigation-inner-checkout">
              <div className="header-navigation-logo-checkout">
                <Logo inNav country={countryModel} onClickLink={noop} isCheckout />
              </div>
              <MainNavigation
                country={countryModel}
                navigation={navigationModel.mainNavigation}
                checkoutNavigation={navigationModel.checkout}
                onTrackLink={noop}
                isCheckout
              />
            </div>
          </div>
        </header>
      </div>
    );
  }
}

export default CheckoutHeader;



// WEBPACK FOOTER //
// ./src/client/js/view/components/MainCheckout/CheckoutHeader/CheckoutHeader.js